module.exports = __webpack_public_path__ + "static/media/i-i.bef360b8.jpg";